import { AxiosRequestConfig } from "axios";
import { Connector } from "slotworks/server/connectors/connector";
import Contract from "slotworks/utils/contract";
declare const require: any;

class OfflineConnector implements Connector {

    // When the demoResults have all been used, which index should currentResult reset to
    public loopIndex: number = 1;

    private currentResult = 0;

    private demoResults: any[] = [];

    public setDemoResults(demoResults: any[]) {
        this.demoResults = demoResults;
    }

    public sendRequest(request: any): Contract<{}> {
        const url = (request as AxiosRequestConfig).url;
        let data: any;

        data = this.demoResults[this.currentResult];

        this.currentResult++;
        if (this.currentResult >= this.demoResults.length) {
            this.currentResult = this.loopIndex;
        }
        return new Contract<any>((resolve) => {
            resolve({ config: { url }, data });
        });
    }

    public setCurrentResult(index: number) {
        this.currentResult = index;
    }

    public onError(method: (message: string) => void): void {
        // No implemented
    }
}

export default new OfflineConnector();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/server/connectors/offline-connector.ts